<template>
    <div class="pro_box">
        <div class="tbs_box">
            <div 
                class="tab_item" 
                :class="[active==item.id?'cactive':'',index==0?'top_border':'']"
                @click="tabswitch(item)"
                v-for="(item,index) of tab" :key="index">
                {{ item.title }}
            </div>
        </div>
        <div class="content_box">
            <div v-if="active==1" class="company">
                <div v-html="company"></div>
            </div>
            <div v-if="active==2" class="contact">
                <div class="font_amap">联系我们</div>
                <div class="contact_amap">
                    <div class="tab_amap">
                        <div
                            :class="[seladd==item.id?'addactive':'']" 
                            class="button_box" 
                            @click="addressswitch(item)"
                            v-for="(item,index) of appoption" 
                            :key="index">
                            {{ item.title }}
                        </div>
                    </div>
                    <el-amap 
                        class="amap-box"  
                        :plugin='plugin' 
                        :zoom="zoom" 
                        :center="center" 
                        :events="events" 
                        :mapStyle="mapStyle">
                        <el-amap-marker 
                        v-for="(marker, i) in markers" 
                        :key="i" 
                        :position="marker"></el-amap-marker>
                    </el-amap>
                    <div class="address">
                        <div>
                            <div class="address_title">公司地址：</div>
                            <div class="address_con">{{ info.address }}</div>
                            <div class="address_title">公司邮箱：</div>
                            <div class="address_con">{{ info.email }}</div>
                            <div class="address_title">联系电话：</div>
                            <div class="address_phone" v-for="(item,index) of info.handle" :key="index">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            active:null,
            appoption:[
                {id:0,title:'地址一'},
                {id:1,title:'地址二'},
            ],
            seladd:null,
            tab:[
                {id:1,title:'公司概况'},
                {id:2,title:'联系我们'},
            ],
            companyInfoList:{},
            info:{},

            center: [91.172488,29.652249], //地图中心点坐
            zoom: 14, //初始化地图显示层级
            mapStyle: "amap://styles/8b6be8ec497009e17a708205348b899a", //设置地图样式
            markers: [
                [91.172488,29.652244]
            ],
            searchOption: {city: "成都",citylimit: true},
            address: "",
            lng: 117.120098,
            lat: 36.6512,
            plugin: [{pName: "Scale"},],
            events: {
                init: (map) => {
                    var geocoder = new AMap.Geocoder({
                        radius: 1000,
                        extensions: "all",
                        city: "全国"
                    });
                    geocoder.getLocation(this.address, (status, result) => {
                        if (status === "complete" && result.geocodes.length) {
                            
                            let lnglat = result.geocodes[0].location
                            this.lng = lnglat.lng;
                            this.lat = lnglat.lat;
                            this.center = [this.lng, this.lat];
                        }
                    });
                },
                moveend: () => {

                },
                zoomchange: () => {

                },
                click: (e) => {
                  
                    
                    // let { lng, lat } = e.lnglat;
                    // this.center = [lng, lat];
                    // this.markers = [[lng, lat]];
                    // this.lng = lng;
                    // this.lat = lat;
                    //  var geocoder = new AMap.Geocoder({
                    //     radius: 1000,
                    //     extensions: "all",
                    //     city: "全国"
                    // });
                    // geocoder.getAddress([this.lng  ,this.lat  ], (status, result) => {
                    //     if (status === 'complete' && result.info === 'OK') {
                    //         this.searchOption.city=result.regeocode.addressComponent.city
                    //     }
                    // });
                // 这里通过高德 SDK 完成。
                },
            },
            company:''
        }
    },
    created(){
        this.seladd=this.appoption[0].id;
        if(this.$route.query.type){
            this.active=Number(this.$route.query.type)
        }else{
            this.active=this.tab[0].id;
        }
        this.axiosdata()
    },
    methods:{
        axiosdata(){
            this.$webhttp.get('v1/web/company').then((res)=>{
                if(res.code==200){
                    this.company=res.data.overview
                    res.data.companyInfoList.forEach((item,index) => {
                        item['handle']=[]
                        if(item.phone.indexOf(',')!=-1){
                            item.phone.split(',').forEach((items)=>{
                                item['handle'].push(items)
                            })
                        }else{
                           item['handle'].push(item.phone)
                        }
                        if(item.email==''&& item.phone=='' && item.address==''){
                            this.appoption.splice(index,1)
                        }
                    });
                    
                    this.companyInfoList=res.data.companyInfoList        
                    this.info=this.companyInfoList[0]
                 
                    this.updatemap(this.info.longitude,this.info.latitude)
                    
                }else{
                    this.$message.error(res.message)
                }
            })
            
        },
        updatemap(lng,lat){
            this.markers =[[lng,lat]];
            this.center=[lng,lat]
        },
        addressswitch(item){
            this.info=this.companyInfoList[item.id]
            this.updatemap(this.info.longitude,this.info.latitude)
            this.seladd=item.id;
        },
        tabswitch(item){
            this.active=item.id
        }
    },
}
</script>
<style lang="less" scoped>
.pro_box{
    width: 100%;
    padding: 0px 160px;
    box-sizing: border-box;
    display: flex;
    min-height: 450px;
    .content_box{
        height: 100%;
        width: 86%;
        padding-top: 40px;
        padding-left: 92px;
        box-sizing: border-box;
        .company{
            box-sizing: border-box;
            margin-bottom: 40px;
        }
        .contact{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            .contact_amap{
                display: flex;
                width: 100%;
                height: 100%;
                position: relative;
                .tab_amap{
                    position: absolute;
                    top: 8px;
                    left: 375px;
                    z-index: 99;
                    display: flex;
                    .addactive{
                        background: #027DFC !important;
                        font-weight: 400;
                        font-size: 12px;
                        color: #FFFFFF;
                        border: 1px solid red;
                    }
                    .button_box:hover{
                        background: #027DFC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #FFFFFF;
                    }
                    .button_box{
                        width: 64px;
                        height: 28px;
                        background: #FFFFFF;
                        border: 1px solid #ECECEC;
                        text-align: center;
                        font-size: 12px;
                        line-height: 28px;
                        cursor: pointer;
                    }
                }
                .address{
                    margin-left: 59px;
                    margin-top: 12px;
                    .address_title{
                        font-weight: 400;
                        font-size: 14px;
                        color: #606060;
                    }
                    .address_phone{
                        font-weight: 400;
                        color: #101010;
                        font-size: 14px;
                    }
                    .address_con{
                        font-weight: 400;
                        margin-bottom: 39px;
                        color: #101010;
                        font-size: 14px;
                    }
                }
                .amap-box{
                    width: 520px;
                    height: 280px;
                    margin-bottom: 45px;
                }
            }
            .font_amap{
                font-weight: normal;
                font-size: 20px;
                color: #101010;
                margin-bottom: 22px;
            }
        }
    }
    .tbs_box{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        .tab_item:hover{
            background: #027DFC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;
        }
        .cactive{
            background: #027DFC !important;
            color: #FFFFFF !important;
        }
        .tab_item{
            border: 1px solid #ECECEC;
            background: #FFFFFF;
            height: 40px;
            width: 200px;
            text-align: center;
            line-height: 40px;
            box-sizing: border-box;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            color: #606060;
            line-height: 40px;
        }
    }
}
</style>